/** @jsxImportSource @emotion/react */

import * as BgImageVip from "assets/common/images/member-vip";
import { currency } from "helpers/formatCurrency";
import { TypeBroadVip } from "types/memberVip";

import { VipDetailsItemStyle } from "./style.index";

export interface ListBgType {
  [x: string]: string;
}
const VipDetailsItem = ({
  level_up_bonus,
  montly_bonus,
  id,
  name,
  birthday_bonus,
}: TypeBroadVip) => {
  const changeBgVip = (id: string) => {
    const valueId = Number(id);

    const listBg: ListBgType = {
      11: BgImageVip.ImageVip1,
      12: BgImageVip.ImageVip2,
      13: BgImageVip.ImageVip3,
      14: BgImageVip.ImageVip4,
      15: BgImageVip.ImageVip5,
      16: BgImageVip.ImageVip6,
      17: BgImageVip.ImageVip7,
      18: BgImageVip.ImageVip8,
      19: BgImageVip.ImageVip9,
    };

    if (valueId > 0 && valueId < 11) {
      return BgImageVip.ImageVip0;
    }
    if (valueId > 19) {
      return BgImageVip.ImageVip10;
    }

    return listBg?.[id];
  };

  const imgBackGroundVip = changeBgVip(id) as string;
  return (
    <div css={VipDetailsItemStyle.wrapper}>
      <img src={imgBackGroundVip} alt="" />
      <div css={VipDetailsItemStyle.textBox}>
        <h4>{name}</h4>
        <span>{name}</span>
      </div>
      <div css={VipDetailsItemStyle.info}>
        <span>{currency(Number(level_up_bonus))}</span>
        <span>{currency(Number(birthday_bonus))}</span>
        <span>{currency(Number(montly_bonus))}</span>
      </div>
    </div>
  );
};

export default VipDetailsItem;
